import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "setup-an-ember-app-with-mirage-for-development-and-testing"
    }}>{`Setup an Ember App with Mirage for Development and Testing`}</h1>
    <p>{`Mirage has a dedicated Ember Addon that makes it easy to get your Ember app setup for development and testing.`}</p>
    <p>{`Check out the dedicated addon's website to learn more:`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.ember-cli-mirage.com/"
      }}>{`https://www.ember-cli-mirage.com/`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      